import * as $ from "jquery";
import CreateAccountInsideCartFields from "../Fields/CreateAccountInsideCartFields";

export default class CreateAccountInsideCartFormValidation
{
	readonly Selector: any;

	constructor()
	{
		this.validate = this.validate.bind(this);
		this.Selector = {
			FORM       : '#step2modalFormNewAccount'
		}
	}

	public validate()
	{
		let rules = Object.assign({},
			CreateAccountInsideCartFields.getFields(this.Selector),
		)

		$(this.Selector.FORM).validate({
			rules: rules,
			errorElement: 'div',
			errorClass:   'invalid-feedback',
		});

		return $(this.Selector.FORM).valid();
	}
}
import * as $ from "jquery";
import CreateAccountInsideCartFields from "../Fields/CreateAccountInsideCartFields";

export default class CreateAccountInsideCartFormValidation
{
	readonly Selector: any;

	constructor()
	{
		this.validate = this.validate.bind(this);
		this.Selector = {
			FORM       : '#step2modalFormNewAccount'
		}
	}

	public validate()
	{
		let rules = Object.assign({},
			CreateAccountInsideCartFields.getFields(this.Selector),
		)

		$(this.Selector.FORM).validate({
			rules: rules,
			errorElement: 'div',
			errorClass:   'invalid-feedback',
		});

		return $(this.Selector.FORM).valid();
	}
}
